import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Successlog from "./Successlog.js";
import Errorlog from './Errorlog.js';
function App() {
    return (
        <div className="App">
            <Routes>
                <Route path ="/" element={<Successlog />} />
                <Route path="/Errorlog" element={< Errorlog/> } />
            </Routes>
        </div>
    );

}
export default App;
